// extracted by mini-css-extract-plugin
module.exports = {"panelContainer":"InquiryWizardStepSpecies_panelContainer__1DYRf","speciesCheckBoxGroup":"InquiryWizardStepSpecies_speciesCheckBoxGroup__3vFAA"};